export default "__VITE_ASSET__DJEOEp9V__"